export class ValidateCronResponseModel {
    valid;
    errorMessage;
}
//# sourceMappingURL=lookup-validate-cron-response.js.map